// @flow
import * as React from 'react';
import { Avatar, Box, Skeleton, Stack, Typography } from '@mui/material';
import { environment } from '../../../environments/environment';

type Props = {
  agent?: {fullName?: React.ReactNode, picUrl?: string | null, email?: string | null}
};
export const AgentView = ({agent}: Props) => {
  return (
    <Stack gap={2} direction={'row'} alignItems={'center'}>
      <Avatar
        src={agent?.picUrl ? environment.cdnUrl + agent.picUrl : undefined}
        sx={{ width: 32, height: 32, bgcolor: '#2d969f' }}
      />
      <Box display={'inline-grid'} flex={1}>
        {!agent && <>
          <Skeleton variant={'rounded'} width={100} height={16} sx={{mb: .5}} />
          <Skeleton variant={'rounded'} width={140} height={16} />
        </>}
        {agent && <>
          <Typography variant={'body2'} align={'left'} noWrap><b>{agent.fullName}</b></Typography>
          <Typography variant={'caption'} align={'left'} noWrap>{agent.email}</Typography>
        </>}
      </Box>
    </Stack>
  );
};
